import styled from 'styled-components'

interface ICardButtonsProps {
    flexColumn?: boolean
    padding?: string
    alignContent?: string
    borderTop?: boolean
    borderBottom?: boolean
    marginTop?: string
    marginBottom?: string
}

export const CardButtons = styled.div<ICardButtonsProps>`
    display: flex;
    flex: 1;
    background-color: #fff;
    flex-direction: ${props => props.flexColumn ? 'column' : 'row'};
    align-items: ${props => props.alignContent || 'center'};
    align-content: ${props => props.alignContent || 'center'};
    justify-content: stretch;
    padding: ${props => props.padding || '10px'};
    margin-top: ${props => props.marginTop || '0px'};
    margin-bottom: ${props => props.marginBottom || '0px'};
    border-top: ${props => props.borderTop ? '1px solid var(--color-gray-4)' : 'none'};
    border-bottom: ${props => props.borderBottom ? '1px solid var(--color-gray-4)' : 'none'};
`